export default __webpack_public_path__ + "static/media/BrainBreak cards82.f9ad0dae.png";